import Vue from 'vue';
import stackDebounce from 'stack-debounce';

var index = (function (fn) { return stackDebounce(fn, Vue.nextTick); });

export default index;
